<template lang="pug">
.v-video-box.video-box
	iframe.video-box__tag.video-box__tag--youtube(v-if="type === 'youtube'"
			:src="youtubeSrc"
			frameborder="0"
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
			allowfullscreen
		)
	v-video.video-box__tag(v-else :play="playState" :autoplay="playState" :mute="playState" :src="src" :loop="loop")
</template>

<script>
export default {
	props: {
		src: {
			type: String,
			default: null
		},

		poster: {
			type: String,
			default: null
		},

		type: {
			type: String,
			default: 'video'
		},

		autoplay: {
			type: Boolean,
			default: false
		},

		loop: {
			type: Boolean,
			default: false
		},

		play: {
			type: Boolean,
			default: false
		}
	},

	watch: {
		play(state) {
			this.playState = state;
		}
	},

	computed: {
		youtubeSrc() {
			let url = new URL(this.src);
			url.searchParams.set('autoplay', '1');
			url.searchParams.set('playsinline', '1');
			url.searchParams.set('mute', (this.mute ? 1 : 0).toString());
			url.searchParams.set('loop', (this.loop ? 1 : 0).toString());
			return url.href;
		}
	},

	data() {
		return {
			playState: this.autoplay,
			mute: true
		};
	}
};
</script>
